import React, { useState } from "react";

interface DateTimeInputProps {
  label: string;
  value: string;
  onChange: (value: string, timestamp: number | null) => void;
  placeholder?: string;
}

const DateTimeInput: React.FC<DateTimeInputProps> = ({
  label,
  value,
  onChange,
  placeholder = "YYYY-MM-DD HH:mm:ss"
}) => {
  const [error, setError] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace('T', ' ');
    const date = new Date(newValue);
    const timestamp = isNaN(date.getTime()) ? null : date.getTime();
    
    if (timestamp === null) {
      setError('Invalid date/time format');
    } else {
      setError('');
    }
    
    onChange(newValue, timestamp);
  };

  return (
    <div className="mb-3 sm:mb-4">
      <label className="block text-foreground font-medium mb-1 sm:mb-2 text-xs sm:text-sm md:text-base">
        {label}
      </label>
      <input
        type="datetime-local"
        value={value.replace(' ', 'T')}
        onChange={handleChange}
        className={`w-full px-3 py-1.5 sm:px-4 sm:py-2 ${error ? 'bg-red-50 border-red-300' : 'bg-yellow-100 border-yellow-300'} text-yellow-800 border rounded-md text-xs sm:text-sm md:text-base transition-all duration-200 focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 focus:outline-none hover:border-yellow-400`}
        placeholder={placeholder}
      />
      {error && <div className="text-red-500 text-xs sm:text-sm mt-1">{error}</div>}
    </div>
  );
};

export default DateTimeInput;
